;(function () {
  angular
    .module('contrast.libraries')
    .controller('ModalTagLibrariesCtrl', [
      '$q',
      '$scope',
      '$uibModalInstance',
      'TagService',
      'request',
      'title',
      'permissions',
      ModalTagLibrariesCtrl
    ])

  function ModalTagLibrariesCtrl(
    $q,
    $scope,
    $uibModalInstance,
    TagService,
    request,
    title,
    permissions
  ) {
    var originalTags = []

    angular.extend($scope, {
      title: title,
      taggingLabel: TagService.getTaggingLabel(),
      model: {
        tags: []
      }
    })

    angular.extend($scope, {
      ok: ok,
      cancel: cancel,
      hasAvailableTags: hasAvailableTags,
      onTaggingSelect: TagService.onTaggingSelect.bind($scope, 'model.tags')
    })

    function init() {
      $q.all({
        availableTags: TagService.getAvailableTagsForLibraries(),
        librariesTags: TagService.getLibrariesTags(request)
      }).then(function (response) {
        $scope.availableTags = response.availableTags
        if (response.librariesTags) {
          var tags = response.librariesTags.tags
          originalTags = tags
          $scope.model.tags = tags
          $scope.model.totalLibraryHashes =
            response.librariesTags.totalLibraryHashes
          $scope.has_tags = originalTags.length > 0
          $scope.bulk_operation =
            $scope.has_tags && request.libraryHashes.length > 1

          _determineIfTagDeleteIsEnabled()
        }
      })
    }

    function _determineIfTagDeleteIsEnabled() {
      $scope.model.disableTagDelete = !permissions.hasPermission('EDIT')
    }

    function ok() {
      var tagsToUpdate = $scope.model.tags
      var addRequest = {
        libraryHashes: request.libraryHashes,
        tagsToUpdate: tagsToUpdate
      }
      var promise = tagsToUpdate.length
        ? TagService.addLibrariesTags(addRequest)
        : $q.resolve()
      var tagsToRemove = _.difference(originalTags, $scope.model.tags)
      if (permissions.hasPermission('EDIT') && tagsToRemove.length) {
        var removeRequest = {
          libraryHashes: request.libraryHashes,
          tagsToUpdate: tagsToRemove
        }
        promise.then(
          function () {
            return TagService.removeLibrariesTags(this)
          }.bind(removeRequest)
        )
      }
      promise.then($uibModalInstance.close)
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel')
    }

    function hasAvailableTags() {
      return (
        !$scope.has_tags &&
        $scope.model.tags &&
        $scope.model.tags.length == 0 &&
        $scope.availableTags &&
        $scope.availableTags.length == 0
      )
    }

    init()
  }
})()
